import React, { useEffect } from 'react';
import { useDataInconsistency } from '@/hooks/useDataInconsistency';
import DataInconsistencyModal from '@/components/DataInconsistencyModal/DataInconsistencyModal';
import { isAuthenticated } from '@/utils/auth/isAuthenticated';

const DataInconsistencyCheck: React.FC = () => {
    const { isModalOpen, handleCloseModal, customersWithoutSub, customersWithInvalidEmails, checkDataInconsistency } = useDataInconsistency();
    const storedData = localStorage.getItem("harenaCowonder");
    const hasStoredAuth = Boolean(storedData && isAuthenticated(storedData));

  useEffect(() => {
    if (hasStoredAuth) {
      checkDataInconsistency();
    }
  }, [isAuthenticated, checkDataInconsistency]);

  return (
    <DataInconsistencyModal
      open={isModalOpen}
      onClose={handleCloseModal}
      inconsistentData={{ customersWithoutSub, customersWithInvalidEmails }}
    />
  );
};

export default DataInconsistencyCheck;
